export default "__VITE_ASSET__B776iuXE__"